import { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import { TPromocode } from '../../types/promocodes';
import { SCREENS } from 'src/constants/screens';
import { formatDate, getDiscountType } from 'src/utils/helpers';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IItem {
  text?: string | number;
  width?: number;
  className: string;
}

interface IProps {
  promocode?: TPromocode;
}

const Item = (item: IItem) => {
  return (
    <li className={`d-flex flex-row align-items-center ${item.className || ''}`}>
      {item.text !== undefined ? <Text type={TEXT.LIST_ROW} text={item.text} noTranslate /> : <Skeleton width={item.width} height={16} />}
    </li>
  );
};

export default class PromocodesListItem extends Component<IProps, {}> {
  render() {
    return (
      <li className="promocode-item d-flex flex-row full-width align-items-center">
        <Item text={this.props.promocode?.promocode} className="pr-4 w-19" width={90} />
        <Item
          text={this.props.promocode ? getDiscountType(this.props.promocode.discount_type, this.props.promocode.provide_as) : undefined}
          className="pr-4 w-20"
          width={110}
        />
        <Item text={this.props.promocode?.amount} className="pr-4 w-15" width={30} />
        <Item text={this.props.promocode ? formatDate(this.props.promocode?.start_date) : undefined} className="pr-4 w-17" width={90} />
        <Item text={this.props.promocode ? formatDate(this.props.promocode?.end_date) : undefined} className="pr-4 w-17" width={90} />
        <Item
          text={this.props.promocode ? this.props.promocode?.minimum_order || 0 : undefined}
          className="promocodes-list__column-min-order w-12"
          width={20}
        />
        <Link to={SCREENS.PROMOCODE_EDIT(this.props.promocode?.id || 0)} className="promocode-item__edit-link" />
      </li>
    );
  }
}
